/* @flow weak */
import React from 'react';

/* This component can wrap another component add create
 * a setInterval on a specified method name of the wrapped
 * components:
 *
 * import doWhileMounted from 'utils/doWhileMounted';
 *
 * class SimpleClass extends React.Component {
 *   hello() {
 *     console.log('hello world!');
 *   }
 *
 *   render() {
 *     return null;
 *   }
 * }
 *
 * export default doWhileMounted(SimpleClass, 'hello', 1000);
 *
 */
function doWhileMounted(Component, functionName: string, msDelay: number) {
  class executer extends React.Component {

    componentDidMount() {
      this.interval = setInterval(this.refs.children[functionName], msDelay);
    }

    componentWillUnmount() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }

    interval: number;

    render() {
      return (
        <Component
          {...this.props}
          {...this.state}
          ref="children"
        />
      );
    }
  }

  return executer;
}

export default doWhileMounted;



// WEBPACK FOOTER //
// ./src/utils/doWhileMounted.js